<template>
  <div class="group group--vertical" :style="{ width: '100%' }" v-if="field.value">
    <div class="section__spacer"></div>
    <div class="group__item">
      <div class="label label--error-inverted">
        {{ value }}
      </div>
    </div>
    <div class="section__spacer"></div>
  </div>
</template>

<script>
import * as Components from ".";

export default {
  extends: Components.CheckoutField,
  name: "checkout-field-message"
};
</script>
